import CircularProgress from "@mui/material/CircularProgress";
import classNames from "classnames";
import React from "react";

interface LoadingProps {
  className?: string;
}

const Loading: React.FC<LoadingProps> = ({ className }) => {
  return (
    <div
      className={classNames("flex w-100 justify-center p-12", className)}
      style={{ color: "#4C4FA2" }}
    >
      <CircularProgress />
    </div>
  );
};

export default Loading;
